import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import produce from 'immer'

import { useToastContext } from '../../../../../contexts'
import { getHandleableError } from '../../../../../utils/errors/isXiaError'
import { requestUpdateGeneralSettings, useGeneralSettings } from '../../data'
import { GeneralForm } from './general-form'

export type FormValues = {
  isMalwareScanningActive: boolean
}

export type FormFieldName = keyof FormValues

export const GeneralData: React.FC = () => {
  const { t } = useTranslation('buyerSettings')
  const { data: generalSettings, isLoading, mutate } = useGeneralSettings()
  const { showToast } = useToastContext()

  const [isRequestRunning, setIsRequestRunning] = useState(false)

  const handleSubmit = async (formData: FormValues) => {
    try {
      setIsRequestRunning(true)

      await submitData(formData)

      // show success toast
      showToast({
        severity: 'success',
        summary: t('general.save.messages.success.summary'),
        detail: t('general.save.messages.success.detail'),
      })
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      // show error toast
      showToast({
        severity: 'error',
        sticky: true,
        summary: t('general.save.messages.failure.summary'),
        detail: errorMessage,
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  const submitData = async (formData: FormValues) => {
    const generalSettings = produce(formData, draft => {
      if (draft) {
        draft.isMalwareScanningActive = formData.isMalwareScanningActive
      }
    })

    if (generalSettings) await requestUpdateGeneralSettings(generalSettings)
  }

  return (
    <GeneralForm
      data={generalSettings}
      handleSubmit={handleSubmit}
      isRequestRunning={isRequestRunning}
    />
  )
}
